import * as Yup from 'yup';

const ProjectSchema = Yup.object({
  projectName: Yup.string()
    .trim()
    .min(2, 'Please enter a project name with at least 2 characters')
    .max(60, 'Please enter a project name with no more than 60 characters')
    .required('Please provide a project name'),
  clientId: Yup.number().required('Please select a client'),
  totalHrs: Yup.number()
    .typeError('Please enter a valid project budget hours)')
    .required('Please provide project budget hours'),
  initialEstimatedHrs: Yup.number()
    .typeError('Please enter a valid project estimated hours)')
    .required('Please provide project estimated hours'),
  allowOverSpent: Yup.boolean(),
  allowManualTask: Yup.boolean(),
  description: Yup.string(),
  startDate: Yup.date().required('Start Date is required'),
  endDate: Yup.date()
    .required('End Date is required')
    .min(Yup.ref('startDate'), 'End Date cannot be before Start Date')
    .test('different-dates', 'Start Date and End Date cannot be the same', function (value) {
      const { startDate } = this.parent;
      return startDate && value && startDate.getTime() !== value.getTime();
    }),
});

export default ProjectSchema;
